import script from "./PartnerBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerBadge.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerBadge.vue?vue&type=style&index=0&id=72154e3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72154e3b"]])

export default __exports__